// ** React Imports
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Button, Grid, Divider, Icon, Radio } from "semantic-ui-react";
import Files from "react-files";
import { uid } from "uid";
import { addsecondAgreement } from "../../store/actions/newSignup";

const Step2 = (props) => {
  const [state, setState] = useState(false);
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [name, setName] = useState(null);
  const dispatch = useDispatch();

  const handleChange = (e, { value }) => {
    setState(value);
  };
  const handleFileChange = (data) => {
    if (data[0] && data[0].type === "application/pdf") {
      setFile(data[0]);
      setName(data[0].name);
      setError(null);
    } else {
      setError("Only PDF allowed");
    }
  };
  const handleNext = () => {
    if (props.userSecondAgreement && !file && !state) {
      props.stepper.next();
      window.scroll(0, 0);
    } else if (!file || !state) {
      setError("Signed agreement & type is required ");
    } else {
      const agreement = {
        agreementId: uid(8),
        file,
        UserId: props.userUid,
        customerType: state,
      };
      dispatch(addsecondAgreement(agreement));
    }
  };

  useEffect(() => {
    if (state && file) setError(null);
  }, [state, file]);

  useEffect(() => {
    if (props.secondAdded && props.stepper) {
      setState(null);
      setFile(null);
      setError(null);
      setName(null);
      props.stepper.next();
      window.scroll(0, 0);
    }
  }, [props.secondAdded]);

  return (
    <>
      <div className="step-header">
        <h2 className="step-header-head">
          Choose the agreement method and Sign the choosen agreement.
        </h2>
        <p className="step-header-text">
          Download and upload the choosen agreement with signature{" "}
          <span className="required">*</span>
        </p>
        {error && <p className="errorText">{error}</p>}
        {props.userSecondAgreement && !error && (
          <p className="errorText">You Can Skip This Step</p>
        )}
      </div>
      <Grid divided="vertically">
        <Grid.Row stackable="true">
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <div className="form-group mb-0">
              <div className="choose-data">
                <Radio
                  name="new"
                  id="new"
                  label="New Student Athelete"
                  value="student"
                  checked={state === "student"}
                  onChange={handleChange}
                />
                <Radio
                  name="new"
                  id="clg"
                  label="College Transfers"
                  value="transfer"
                  checked={state === "transfer"}
                  onChange={handleChange}
                />
              </div>
              {state && (
                <div className="cu-center">
                  <a
                    className="view-pdf"
                    target="_blank"
                    rel="noreferrer"
                    href={
                      state === "transfer"
                        ? props.transferURL
                        : props.athleteURL
                    }
                    download
                  >
                    <div>
                      <Icon name="file pdf" />
                      <span>Download</span>
                    </div>
                  </a>
                </div>
              )}
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Divider horizontal>&</Divider>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <div className="form-group cu-center">
                <Files
                  className="files-dropzone"
                  onChange={handleFileChange}
                  accepts={[".pdf"]}
                  clickable
                  multiple={false}
                >
                  <label className="btn-cu ui green button btn-cu">
                    <Icon name="upload" />
                    Upload the service agreement
                  </label>
                </Files>
                {name && <p className="note">{name}</p>}
              </div>
            </Grid.Column>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <div className="footer-btn-data">
        <Button
          onClick={() => {
            setState(null);
            setFile(null);
            setError(null);
            setName(null);
            props.stepper.previous();
            window.scroll(0, 0);
          }}
        >
          Back
        </Button>

        <Button
          primary
          onClick={handleNext}
          loading={props.secondAdding}
          disabled={error}
        >
          Next
        </Button>
      </div>
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  let athleteUrl = null;
  let transferUrl = null;
  if (
    ownProps.athleteAgreement.length > 0 &&
    ownProps.athleteAgreement.length < 2
  ) {
    athleteUrl = ownProps.athleteAgreement[0].fileUrl;
  }
  if (
    ownProps.transferAgreement.length > 0 &&
    ownProps.transferAgreement.length < 2
  ) {
    transferUrl = ownProps.transferAgreement[0].fileUrl;
  }
  return {
    athleteURL: athleteUrl,
    transferURL: transferUrl,
    signup: state.signup,
    secondAdding: state.signup.secondAdding,
    secondAdded: state.signup.secondAdded,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: "testPriceList",
    },
  ])
)(Step2);
